import { render } from "./j-infinite-loading.vue?vue&type=template&id=3d7499f2&scoped=true"
import script from "./j-infinite-loading.vue?vue&type=script&lang=js"
export * from "./j-infinite-loading.vue?vue&type=script&lang=js"

import "./j-infinite-loading.vue?vue&type=style&index=0&id=3d7499f2&scoped=true&lang=less"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7499f2"]])

export default __exports__